import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../../utl/models/Message";
import { UpsellState } from "../models/UpsellsState";

const setMessage = (state: UpsellState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;